import React from 'react'
import { observer } from 'mobx-react-lite'
import { FilterItem, FilterManager } from '@app/managers/filters'
import { classNames } from '@app/utils/classes'
import { GrCheckbox, GrCheckboxSelected } from 'react-icons/gr'

// clean format the name to WCAG
const cleanName = (name: string) => {
  if (name.startsWith('WCAG')) {
    const startPoint = name.indexOf('.')
    if (startPoint !== -1) {
      return name.slice(startPoint + 1)
    }
  }
  return name
}

export const CheckBox = observer(
  ({
    name,
    className,
    value,
    checked: checkedItem,
  }: FilterItem & { name: string; className?: string; value?: string }) => {
    const f = FilterManager.filters.get(value ?? name) ?? {}
    const checked = checkedItem ?? f.checked

    return (
      <div
        className={classNames(
          'px-3 py-2 flex place-items-center space-x-2 overflow-hidden text-xs capitalize',
          className || ''
        )}
      >
        {!checked ? (
          <GrCheckbox className='grIcon text-blue-600' />
        ) : (
          <GrCheckboxSelected className='grIcon' />
        )}
        <div className='truncate'>{name && cleanName(name)}</div>
      </div>
    )
  }
)
